<template>
  <div id="app">
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'App',
  created: function () {
    this.$router.push('/')
  }
}
</script>

<style>
body {
  margin:auto;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #fff;
  background: #DDE1EC;
  min-width: 1040px;
}
@media (max-width: 992px) {
#app {
min-width: 100%;
height: auto;
}
}
</style>



// WEBPACK FOOTER //
// src/App.vue